import { Typography } from '@mui/material';

import {
  SiteTitle,
  StandardHeader,
  LanguagePopover,
} from '@larvitu/shared/mui/ui-components';

import { navConfig } from '../../routes';

import { MobileNav, NavDesktop } from './navigation';

import type { StandardHeaderProps } from '@larvitu/shared/mui/ui-components';
import type React from 'react';
import type { FC } from 'react';

export type HeaderProps = Omit<
  StandardHeaderProps,
  'children' | 'navConfig' | 'navDesktop' | 'navMobile'
>;

export const Header: FC<HeaderProps> = (props) => (
  <StandardHeader
    LanguagePopover={LanguagePopover}
    // @ts-ignore
    navConfig={navConfig}
    Label={(labelProps): React.JSX.Element => (
      <SiteTitle fontWeight="bold" marginLeft={2} {...labelProps}>
        {process.env.NEXT_PUBLIC_PAGE_TITLE}
      </SiteTitle>
    )}
    // @ts-ignore
    navDesktop={NavDesktop}
    navMobile={(navMobileProps): React.JSX.Element => (
      <MobileNav
        label={(): React.JSX.Element => (
          <Typography>Dr. Götz Geiges</Typography>
        )}
        navConfig={navMobileProps.navConfig as any}
      />
    )}
    {...props}
  />
);
/*{...navMobileProps}*/
